module.exports = __webpack_public_path__ + "img/feat_2.15da7a56.png";